/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Trust_RefundsInputs */

const en_pricing_trust_refunds = /** @type {(inputs: Pricing_Trust_RefundsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed videos are refunded automatically`)
};

const es_pricing_trust_refunds = /** @type {(inputs: Pricing_Trust_RefundsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los videos fallidos se reembolsan automáticamente`)
};

/**
* | output |
* | --- |
* | "Failed videos are refunded automatically" |
*
* @param {Pricing_Trust_RefundsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_trust_refunds = /** @type {((inputs?: Pricing_Trust_RefundsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Trust_RefundsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_trust_refunds(inputs)
	return es_pricing_trust_refunds(inputs)
});